import { useState } from "react";
import CardCustom from "../../components/card";
import { TableCustomProps } from "../../components/table/table";
import TableMaterial from "../../components/tableMaterial/tableMaterial";
import ModalUI from "../../components/modalUI/ModalUI";
import ButtonUI from "../../components/button/buttons";
import HelpIcon from "@mui/icons-material/Help";
import { formatToMexicanPesos } from "../../components/utils/format";
import useFetchBankTransferByUser from "../../service/userBankTransfer/getBankTransfer";
import StatusLabel from "../../components/utils/StatusLabel";
import BankTransferConfirmationModal from "./modalTransfer/modalTranser";

const BankTransfer = () => {
//  const storedToken = sessionStorage.getItem("userData");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endStarDate, setEndStartDate] = useState<Date | null>(null);
  const [selectedTransaction, setSelectTransaction] = useState<null>(null);

  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [status, setStatus] = useState("ALL");

  const handleOpenModal = (transaction: any) => {
    setOpenModal(true);
    setSelectTransaction(transaction);
    // setOpenModal(true);
  };

  const transformDataToTable = (
    transfers: any[]
  ): TableCustomProps["rows"] => {

    return transfers.map((transfer) => ({

      name: transfer.full_name,
      move_name: transfer.description,
      move_id: transfer.move_id,
      email:  transfer.email ?? 'N/A',
      amount: formatToMexicanPesos(transfer.amount) ,
      comision: transfer?.comission ?  formatToMexicanPesos(transfer?.comission?.api_commission?.commission ): formatToMexicanPesos(transfer?.amount_with_comision),
      //country: transaction.currency,
      date: new Date(transfer?.created_at).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Mexico_City",
      }),
      status: (<StatusLabel value={transfer.status} />),

      info: (
        <div>
          <ButtonUI
            icon={<HelpIcon />}
            variant="text"
            onClick={() => handleOpenModal(transfer)}
          />
        </div>
      ),
    }));
  };

  const { bankTransfer, loading, error } = useFetchBankTransferByUser(
    page,
    rowsPerPage,
    {
      email: email || undefined,
      status: status || undefined,
      dateFrom: startDate ? startDate.toISOString() : undefined,
      dateTo: endStarDate ? endStarDate.toISOString() : undefined,
    }
  );

  const dataTable: any = {
    columns: [
      { id: "name", label: "Nombre" },
      {id: 'store', label: 'Tienda'},
      { id: "move_name", label: "Nombre de movimiento" },
      { id: "move_id", label: "Clave de rastreo" },
      { id: "email", label: "Correo" },
      { id: "amount", label: "Pago" },
      { id: "comision", label: "Comision" },
      //{ id: "country", label: "Moneda" },
      { id: "date", label: "Fecha" },
      { id: "status", label: "Estado" },
      { id: "info", label: "Info" },
    ],
    rows: transformDataToTable(  bankTransfer?.response?.data || []),
  };

  const onChangeEmail = (e: any) => {
    // setEmail(e.target.value);
  };

  const handleSearchClick = () => {
    setSearchClicked((prev) => !prev);
  };

  const onClickCleanFilters = () => {
    setEndStartDate(null);
    setStartDate(null);
    setStatus("ALL");
  };

 
  return (
    <div>
        <CardCustom classCustom="activity_card">
          <h2>Tranferencias Bancarias</h2>
          <TableMaterial
          isClean={true}
            setStatus={setStatus}
            status={status}
            onClickFilters={onClickCleanFilters}
            valueInput={email}
            onClickSearch={handleSearchClick}
            onChangeInput={onChangeEmail}
            isDate={true}
            setEndDate={setEndStartDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endStarDate}
            totalRows={bankTransfer?.response?.pagination?.countData}
            setPage={setPage}
            page={page}
            setRowsPerPage={setRowsPerPage}
            rowsPerPage={rowsPerPage}
            report={true}
            columns={dataTable.columns}
            rows={dataTable?.rows || []}
            loading={loading}
            isSearch={false}
          />
        </CardCustom>
      <ModalUI
        children={<BankTransferConfirmationModal data={selectedTransaction || []} />}
        title="Información de transacción"
        open={openModal}
        setOpen={setOpenModal}
      />
    </div>
  );
};

export default BankTransfer;
